import { render, staticRenderFns } from "./seatComponents.vue?vue&type=template&id=528311d2&scoped=true&"
import script from "./seatComponents.vue?vue&type=script&lang=js&"
export * from "./seatComponents.vue?vue&type=script&lang=js&"
import style0 from "./seatComponents.vue?vue&type=style&index=0&id=528311d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528311d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('528311d2')) {
      api.createRecord('528311d2', component.options)
    } else {
      api.reload('528311d2', component.options)
    }
    module.hot.accept("./seatComponents.vue?vue&type=template&id=528311d2&scoped=true&", function () {
      api.rerender('528311d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/travel/components/seatComponents.vue"
export default component.exports